/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getCryptoLightningReceiveLimits} from '../api'

 export const useQueryGetCryptoLightningReceiveLimits = createReactQueryHook('getCryptoLightningReceiveLimits', getCryptoLightningReceiveLimits)
